/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';

interface SqlImportsDatabaseDetailsArgs {
  database?: SqlImportDatabaseModel;
  location?: string;
}

export default class SqlImportsDatabaseDetails extends Component<SqlImportsDatabaseDetailsArgs> {
  get databaseName() {
    if (this.args.database?.name) {
      return this.args.database.name;
    }

    return htmlSafe(
      `<span class="font-medium">${this.args.database?.projectId}</span> in <span class="font-medium">${this.args.location}</span>`,
    );
  }
}
